import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="faqs"
export default class extends Controller {
  static targets = ["answer", "icon", "item"];

  connect() {
    this.answerTargets[0].style.display = "block";
    this.iconTargets[0].textContent = "-";
  }

  toggle(event) {
    const clickedItem = event.currentTarget;

    // Find which answer and icon belong to this item
    const answerIndex = this.itemTargets.indexOf(clickedItem);
    const answer = this.answerTargets[answerIndex];
    const icon = this.iconTargets[answerIndex];

    const isOpen = answer.style.display === "block";

    // Close all other answers
    this.closeAll();

    if (!isOpen) {
      answer.style.display = "block";
      icon.textContent = "−";
    }
  }

  closeAll() {
    this.answerTargets.forEach((answer) => {
      answer.style.display = "none";
    });
    this.iconTargets.forEach((icon) => {
      icon.textContent = "+";
    });
  }
}
